const showPresets=[
  {
    "title": "BLOODHOUND GANG",
    "support": "NERF HERDER",
    "date": "FRI MARCH 7, 1997 8:00 PM $10",
    "sourceUrl": "https://nebnewspapers.unl.edu/lccn/sn96080312/1997-03-07/ed-1/seq-9.pdf",
    "sourceNote": "Date and bands confirmed. Newspaper lists 7:30 PM and $9; the supplied listing says 8:00 PM and $10."
  },
  {
    "title": "PEARL JAM",
    "support": "TRIBE AFTER TRIBE",
    "date": "SUNDAY MAY 3, 1992",
    "sourceUrl": "https://pearljamconcertchronology.com/1992/",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "GREEN DAY",
    "support": "PANSY DIVISION",
    "date": "THURSDAY JULY 14, 1994",
    "sourceUrl": "https://greendaylive.fm/setlists/green-day-july-14-1994-ranch-bowl-omaha-ne-usa.html",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "RED HOT CHILI PEPPERS",
    "support": "",
    "date": "WEDNESDAY OCTOBER 11, 1989",
    "sourceUrl": "https://www.worldradiohistory.com/Archive-All-Music/Hard-Report/1989/Hard-Report-1989-10-13.pdf",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "311",
    "support": "YARD APES",
    "date": "SATURDAY JANUARY 25, 1992",
    "sourceUrl": "https://311archive.com/performance-history",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "THE AQUABATS",
    "support": "THE PHENOMENAUTS",
    "date": "SATURDAY JULY 9, 2005",
    "sourceUrl": "https://www.concertarchives.org/bands/the-aquabats?page=30",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "PANTERA",
    "support": "WHITE ZOMBIE",
    "date": "THURSDAY DECEMBER 10, 1992",
    "sourceUrl": "https://www.concertarchives.org/concerts/pantera--6250183",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "WARRANT",
    "support": "",
    "date": "TUESDAY SEPTEMBER 14, 1999",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438/photos?page=3",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "SKID ROW",
    "support": "",
    "date": "WEDNESDAY MAY 17, 1995",
    "sourceUrl": "https://www.concertarchives.org/concerts/skid-row--6388375",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "HELMET",
    "support": "MELVINS",
    "date": "SUNDAY JULY 6, 1997",
    "sourceUrl": "https://themelvins.net/wiki/index.php/Melvins_Tour_Dates_1997",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "L7",
    "support": "",
    "date": "WEDNESDAY SEPTEMBER 3, 1997",
    "sourceUrl": "https://www.setlist.fm/setlist/l7/1997/ranch-bowl-omaha-ne-bbb9d66.html",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "STRYPER",
    "support": "BRIDE",
    "date": "THURSDAY DECEMBER 5, 1991",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438/videos",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "KING'S X",
    "support": "THE LOST",
    "date": "SUNDAY MAY 31, 1992",
    "sourceUrl": "https://tourdatesearch.com/tourdates/artist/459/kings-x?p=55",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "ANI DIFRANCO",
    "support": "",
    "date": "FRIDAY JULY 2, 1999",
    "sourceUrl": "https://www.setlist.fm/setlist/ani-difranco/1999/ranch-bowl-omaha-ne-63ecea1b.html",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "REVEREND HORTON HEAT",
    "support": "LET'S GO BOWLING",
    "date": "SUNDAY FEBRUARY 1, 1998",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "FINCH",
    "support": "VENDETTA RED",
    "date": "THURSDAY MAY 26, 2005",
    "sourceUrl": "https://www.songkick.com/de/venues/38570-ranch-bowl",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "MINDLESS SELF INDULGENCE",
    "support": "HASTE THE DAY",
    "date": "FRIDAY MAY 20, 2005",
    "sourceUrl": "https://www.setlist.fm/setlist/mindless-self-indulgence/2005/ranch-bowl-omaha-ne-2bd9d496.html",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "AGNOSTIC FRONT",
    "support": "FULL BLOWN CHAOS",
    "date": "SUNDAY MAY 15, 2005",
    "sourceUrl": "https://stg.lambgoat.com/news/4793/agnostic-front-full-blown-chaos-etc-tour/",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "DREDG",
    "support": "CIRCA SURVIVE",
    "date": "THURSDAY MAY 5, 2005",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "HANK WILLIAMS III",
    "support": "",
    "date": "MONDAY APRIL 25, 2005",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "BUFFALO TOM",
    "support": "SAINT JOHNNY",
    "date": "MONDAY, FEBRUARY 21, 1994",
    "sourceUrl": "https://www.worldradiohistory.com/Archive-All-Music/Pollstar/90s/94/Pollstar-1994-02-14.pdf",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "BOB MOULD",
    "support": "",
    "date": "SUNDAY OCTOBER 3, 1993",
    "sourceUrl": "https://manuals.plus/m/0576051280e019b592f2d9d68b98e01585c38fabcf1fd7ae16de810c4655269a",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "TOAD THE WET SPROCKET",
    "support": "MARVIN ETZIONI (FORMERLY OF LONE JUSTICE)",
    "date": "MONDAY, FEBRUARY 24, 1992",
    "sourceUrl": "https://www.geocities.ws/concertarchive/toad_1992.html",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "NILS LOFGREN",
    "support": "",
    "date": "SUNDAY MARCH 3, 1996",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "THE URGE",
    "support": "2 SKINNEE J's / KOTTONMOUTH KINGS / SPRUNG MONKEY",
    "date": "WEDNESDAY JULY 8, 1998 AND THURSDAY JULY 9, 1998",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "THE URGE",
    "support": "",
    "date": "FRIDAY DECEMBER 18, 1998",
    "sourceUrl": "https://chsfomaha.org/wp-content/uploads/2022/10/1998-12.pdf",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "COLLECTIVE SOUL",
    "support": "",
    "date": "MONDAY, MAY 30, 1994",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "Down",
    "support": "",
    "date": "SUNDAY AUGUST 18TH, 2002",
    "sourceUrl": "https://www.setlist.fm/setlist/down/2002/ranch-bowl-omaha-ne-53d31b8d.html",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "Omaha metal fest 1",
    "support": "Faith In Pain / FACE CAGE / Parasitic Possession / Chrome Semic FIASCO / Dirtfedd / HATRED / Drawn In Sorrow / Coff Drops / Idle Apathy / Narcotic Self / Indrid Cold",
    "date": "saturday april 12",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "NIGHTMARE",
    "support": "SOCIAL DECAY / HOUSE OF COMMONS / HEAVY CHEESECAKE",
    "date": "THURS, NOV 5",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "KING'S X",
    "support": "JRZ System",
    "date": "WEDNESDAY, APRIL 27, 1994",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "PRONG",
    "support": "COURSE OF EMPIRE",
    "date": "TUESDAY, APRIL 26, 1994",
    "sourceUrl": "https://www.worldradiohistory.com/Archive-All-Music/Pollstar/90s/94/Pollstar-1994-04-04.pdf",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "FIGHT",
    "support": "",
    "date": "WEDNESDAY, FEBRUARY 2, 1994",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "EVERY MOTHERS NIGHTMARE",
    "support": "",
    "date": "SUNDAY, MARCH 7, 1993",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "GHOST OF AN AMERICAN AIRMAN",
    "support": "",
    "date": "THURSDAY, NOVEMBER 11, 1993",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "ACCEPT",
    "support": "I.R.S. RECORDS RECORDING ARTIST LILLIAN AXE / STRIP MIND",
    "date": "THURSDAY OCTOBER 28, 1993",
    "sourceUrl": "https://www.worldradiohistory.com/Archive-All-Music/Pollstar/90s/93/Pollstar-1993-10-04.pdf",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "SAIGON KICK",
    "support": "",
    "date": "WEDNESDAY, NOVEMBER 18, 1992",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "LOVE ON ICE / ELECTRIC LOVE HOGS",
    "support": "NIGHTMARE",
    "date": "MONDAY, JUNE 22, 1992",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "MARILYN MANSON",
    "support": "Clutch / THE ZEROS",
    "date": "SUNDAY OCTOBER 15, 1995",
    "sourceUrl": "https://manson.wiki/1995/10/15_Omaha%2C_NE",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "WHITE ZOMBIE",
    "support": "MONSTER MAGNET",
    "date": "TUESDAY, MARCH 9, 1993",
    "sourceUrl": "https://www.worldradiohistory.com/Archive-All-Music/Foundations/Foundations-1993-03-01.pdf",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "CANDLEBOX",
    "support": "",
    "date": "THURSDAY SEPTEMBER 16, 1993",
    "sourceUrl": "https://www.setlist.fm/setlist/candlebox/1993/ranch-bowl-omaha-ne-4b569f66.html",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "TYPE \"O\" NEGATIVE",
    "support": "SISTER MACHINE GUN",
    "date": "SUNDAY FEBRUARY 2, 1997",
    "sourceUrl": "https://www.groundzero-brooklyn.com/ton/tour/ustour97_1.html",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "STEELHEART",
    "support": "",
    "date": "SUNDAY, OCTOBER 11, 1992",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "gin blossoms",
    "support": "CRASH VEGAS / LOST LUGGAGE",
    "date": "WEDNESDAY, APRIL 28, 1993",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "BLIND MELON",
    "support": "FIFTH OF MAY / NO LEFT STONE",
    "date": "MONDAY, FEBRUARY 22, 1993",
    "sourceUrl": "https://www.blindmelonarticles.com/1993/shows/1993-02-22_omaha.html",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "CANDLEBOX",
    "support": "GRETA",
    "date": "TUESDAY, NOVEMBER 30, 1993",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "injected",
    "support": "",
    "date": "11/20 7pm",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "ASPHALT BALLET",
    "support": "TIGHT FIT",
    "date": "THURSDAY, APRIL 1, 1993",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "WHITE TRASH",
    "support": "",
    "date": "THURSDAY, MAY 5, 1994",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "WARRANT",
    "support": "SAVAGE GRACE",
    "date": "SUNDAY, JANUARY 23, 1994",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "STONE TEMPLE PILOTS",
    "support": "",
    "date": "SATURDAY, NOVEMBER 14, 1992",
    "sourceUrl": "https://www.concertarchives.org/concerts/stone-temple-pilots-11a17741-346c-4991-8464-7287793ba6d1",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "BROTHER CANE",
    "support": "",
    "date": "TUESDAY JULY 6, 1993",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "TESTAMENT",
    "support": "GREEN JELLO / PRO-PAIN",
    "date": "THURSDAY, APRIL 8, 1993",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "FASTER PUSSYCAT",
    "support": "MY SISTER'S MACHINE",
    "date": "MONDAY, AUGUST 31, 1992",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "hollowed CD RELEASE PARTY",
    "support": "CHARACTER ZERO / TRUTH IN RUIN / DIRT FEDD",
    "date": "SATURDAY DECEMBER 14, 2002",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "TRIXTER",
    "support": "",
    "date": "",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "EVERY MOTHERS NIGHTMARE",
    "support": "NIGHTMARE / CELLOPHANE CEILING / RAGDOLL",
    "date": "MONDAY, NOVEMBER 16, 1992",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "SAVATAGE",
    "support": "",
    "date": "WEDNESDAY SEPTEMBER 1, 1993",
    "sourceUrl": "https://www.setlist.fm/setlists/savatage-7bd68210.html?page=30",
    "sourceNote": "September 1 is listed in setlist.fm and one Pollstar issue; other advance schedules listed September 3."
  },
  {
    "title": "WHITE ZOMBIE",
    "support": "PRONG",
    "date": "SATURDAY, JANUARY 29, 1994",
    "sourceNote": "Date appears in tour records, but the venue is listed as Omaha Convention Hall rather than Ranch Bowl.",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "deftones",
    "support": "WILL HAVEN",
    "date": "live wednesday december tenth, 1997",
    "sourceUrl": "https://www.setlist.fm/setlist/deftones/1997/ranch-bowl-omaha-ne-23f2b0eb.html",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "fIREHOSE",
    "support": "BAZOOKA",
    "date": "MONDAY, MAY 10, 1993",
    "sourceUrl": "https://tourdatesearch.com/tourdate/1993-05-10/11071/ranch-bowl-in-omaha-ne-usa",
    "sourceNote": "Date confirmed. A contemporary newspaper names Fever Trees as support; the supplied listing names Bazooka."
  },
  {
    "title": "311",
    "support": "FEVER TREE / BEEF CURTAINS",
    "date": "THURSDAY, APRIL 29, 1993",
    "sourceUrl": "https://311archive.com/performance-history",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "CORROSION OF CONFORMITY",
    "support": "MACHINE HEAD / DRAIN",
    "date": "SUNDAY AUGUST 10, 1997",
    "sourceUrl": "https://www.concertarchives.org/concerts/corrosion-of-conformity--6521571",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "NUCLEAR ASSAULT",
    "support": "DIABOLIC POSSESSION",
    "date": "WEDNESDAY, APRIL 7, 1993",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "NEW MUSIC MONDAY",
    "support": "BITZ-N-PIECES / ABADON / LAST HOPE",
    "date": "MARCH 29, 1993",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "BUZZO",
    "support": "Gauge / Hollowed / Second Coming / Cloaca / Notch",
    "date": "FRIDAY MARCH 1ST, 2002",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "BANG TANGO",
    "support": "",
    "date": "SATURDAY, SEPTEMBER 12, 1992",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "ANTHRAX",
    "support": "THE DEFTONES / LIFE OF AGONY",
    "date": "SUNDAY DECEMBER 10, 1995",
    "sourceNote": "A July 18, 1995 bill with these bands is documented; the supplied December 10 date remains unconfirmed.",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "CANNIBAL CORPSE",
    "support": "DARK FUNERAL / PISSING RAZORS / INCANTATION",
    "date": "SUNDAY APRIL 14TH, 2002",
    "sourceUrl": "https://www.concertarchives.org/bands/cannibal-corpse?page=5&year=2002",
    "sourceNote": "Source confirms the headliner, date and venue; other bill details may not be independently confirmed."
  },
  {
    "title": "SOUTHGANG",
    "support": "SLAMMIN' GLADYS",
    "date": "WEDNESDAY, DECEMBER 9, 1992",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "JUROR 13 / ForNever",
    "support": "Dementia / Size 13",
    "date": "Monday June 21st",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "LEAD / ForNever",
    "support": "",
    "date": "WEDNESDAY, MAY 5TH",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "ForNever / Sutter Cain",
    "support": "Lower Case I",
    "date": "Monday March 15th at 8pm",
    "verificationStatus": "NOT VERIFIED"
  },
  {
    "title": "311",
    "support": "GROOVEYARDS",
    "isoDate": "1991-06-10",
    "date": "MON JUNE 10, 1991",
    "sourceUrl": "https://311archive.com/performance-history"
  },
  {
    "title": "311",
    "support": "",
    "isoDate": "1991-07-01",
    "date": "MON JULY 1, 1991",
    "sourceUrl": "https://311archive.com/performance-history"
  },
  {
    "title": "311",
    "support": "",
    "isoDate": "1991-07-08",
    "date": "MON JULY 8, 1991",
    "sourceUrl": "https://311archive.com/performance-history"
  },
  {
    "title": "311",
    "support": "",
    "isoDate": "1991-07-15",
    "date": "MON JULY 15, 1991",
    "sourceUrl": "https://311archive.com/performance-history"
  },
  {
    "title": "311",
    "support": "CELLOPHANE CEILING",
    "isoDate": "1991-09-14",
    "date": "SAT SEPTEMBER 14, 1991",
    "sourceUrl": "https://311archive.com/performance-history"
  },
  {
    "title": "311",
    "support": "",
    "isoDate": "1991-09-20",
    "date": "FRI SEPTEMBER 20, 1991",
    "sourceUrl": "https://311archive.com/performance-history"
  },
  {
    "title": "311",
    "support": "CELLOPHANE CEILING",
    "isoDate": "1991-11-16",
    "date": "SAT NOVEMBER 16, 1991",
    "sourceUrl": "https://311archive.com/performance-history"
  },
  {
    "title": "311",
    "support": "FEVER TREES / MOUSETRAP",
    "isoDate": "1991-12-23",
    "date": "MON DECEMBER 23, 1991",
    "sourceUrl": "https://311archive.com/performance-history"
  },
  {
    "title": "311",
    "support": "YARD APES",
    "isoDate": "1991-12-29",
    "date": "SUN DECEMBER 29, 1991",
    "sourceUrl": "https://311archive.com/performance-history"
  },
  {
    "title": "311",
    "support": "NINE DAY WONDER / MARCH HARES",
    "isoDate": "1991-12-30",
    "date": "MON DECEMBER 30, 1991",
    "sourceUrl": "https://311archive.com/performance-history"
  },
  {
    "title": "311",
    "support": "",
    "isoDate": "1992-12-01",
    "date": "TUE DECEMBER 1, 1992",
    "sourceUrl": "https://311archive.com/performance-history"
  },
  {
    "title": "311",
    "support": "",
    "isoDate": "1992-12-23",
    "date": "WED DECEMBER 23, 1992",
    "sourceUrl": "https://311archive.com/performance-history"
  },
  {
    "title": "311",
    "support": "",
    "isoDate": "1992-12-29",
    "date": "TUE DECEMBER 29, 1992",
    "sourceUrl": "https://311archive.com/performance-history"
  },
  {
    "title": "311",
    "support": "",
    "isoDate": "1993-01-01",
    "date": "FRI JANUARY 1, 1993",
    "sourceUrl": "https://311archive.com/performance-history"
  },
  {
    "title": "311",
    "support": "",
    "isoDate": "1993-01-05",
    "date": "TUE JANUARY 5, 1993",
    "sourceUrl": "https://311archive.com/performance-history"
  },
  {
    "title": "311",
    "support": "",
    "isoDate": "1993-12-23",
    "date": "THU DECEMBER 23, 1993",
    "sourceUrl": "https://311archive.com/performance-history"
  },
  {
    "title": "311",
    "support": "SECRET SKIN",
    "isoDate": "1993-12-29",
    "date": "WED DECEMBER 29, 1993",
    "sourceUrl": "https://311archive.com/performance-history"
  },
  {
    "title": "311",
    "support": "SECRET SKIN / THE KIND",
    "isoDate": "1994-06-11",
    "date": "SAT JUNE 11, 1994",
    "sourceUrl": "https://311archive.com/performance-history"
  },
  {
    "title": "THE SMASHING PUMPKINS",
    "support": "311",
    "isoDate": "1991-06-15",
    "date": "SAT JUNE 15, 1991",
    "sourceUrl": "https://www.concertarchives.org/concerts/smashing-pumpkins-311"
  },
  {
    "title": "LIVING STONE",
    "support": "THE LABELS / PARTS PER MILLION",
    "isoDate": "1997-11-03",
    "date": "MON NOVEMBER 3, 1997",
    "sourceUrl": "https://bradhoshawmusic.com/past-shows"
  },
  {
    "title": "LIVING STONE",
    "support": "LIFE IN GENERAL / JONSTONES",
    "isoDate": "1998-01-12",
    "date": "MON JANUARY 12, 1998",
    "sourceUrl": "https://bradhoshawmusic.com/past-shows"
  },
  {
    "title": "LIVING STONE",
    "support": "20 CLASS A / DESEO",
    "isoDate": "1998-01-28",
    "date": "WED JANUARY 28, 1998",
    "sourceUrl": "https://bradhoshawmusic.com/past-shows"
  },
  {
    "title": "THE FIGGS",
    "support": "",
    "isoDate": "1997-07-15",
    "date": "TUE JULY 15, 1997",
    "sourceUrl": "https://thefiggs.net/tour-history/"
  },
  {
    "title": "CANNIBAL CORPSE",
    "support": "",
    "isoDate": "1996-12-06",
    "date": "FRI DECEMBER 6, 1996",
    "sourceUrl": "https://www.45cat.com/live/venue/ranch-bowl"
  },
  {
    "title": "WEEZER",
    "support": "",
    "isoDate": "1997-07-05",
    "date": "SAT JULY 5, 1997",
    "sourceUrl": "https://www.45cat.com/live/venue/ranch-bowl"
  },
  {
    "title": "CHEAP TRICK",
    "support": "",
    "isoDate": "1997-07-09",
    "date": "WED JULY 9, 1997",
    "sourceUrl": "https://www.45cat.com/live/venue/ranch-bowl"
  },
  {
    "title": "THE CRAMPS",
    "support": "GUITAR WOLF / DEMOLITION DOLL RODS",
    "isoDate": "1997-11-28",
    "date": "FRI NOVEMBER 28, 1997",
    "sourceUrl": "https://www.45cat.com/live/venue/ranch-bowl"
  },
  {
    "title": "CANNIBAL CORPSE",
    "support": "ANGELCORPSE",
    "isoDate": "1998-09-15",
    "date": "TUE SEPTEMBER 15, 1998",
    "sourceUrl": "https://www.45cat.com/live/venue/ranch-bowl"
  },
  {
    "title": "REVEREND HORTON HEAT",
    "support": "LOS STRAITJACKETS",
    "isoDate": "1999-12-16",
    "date": "THU DECEMBER 16, 1999",
    "sourceUrl": "https://www.45cat.com/live/venue/ranch-bowl"
  },
  {
    "title": "SOUTHERN CULTURE ON THE SKIDS",
    "support": "",
    "isoDate": "1996-07-23",
    "date": "TUE JULY 23, 1996",
    "sourceUrl": "https://www.45cat.com/live/venue/ranch-bowl"
  },
  {
    "title": "THE CRAMPS",
    "support": "REVEREND HORTON HEAT",
    "isoDate": "1992-03-10",
    "date": "TUE MARCH 10, 1992",
    "sourceUrl": "https://www.45cat.com/live/venue/ranch-bowl"
  },
  {
    "title": "WIDESPREAD PANIC",
    "support": "",
    "isoDate": "1995-08-01",
    "date": "TUE AUGUST 1, 1995",
    "sourceUrl": "https://www.panicstream.com/vault/tag/ranch-bowl/"
  },
  {
    "title": "WIDESPREAD PANIC",
    "support": "",
    "isoDate": "1997-07-01",
    "date": "TUE JULY 1, 1997",
    "sourceUrl": "https://www.panicstream.com/vault/tag/ranch-bowl/"
  },
  {
    "title": "WIDESPREAD PANIC",
    "support": "",
    "isoDate": "1999-07-13",
    "date": "TUE JULY 13, 1999",
    "sourceUrl": "https://www.panicstream.com/vault/tag/ranch-bowl/"
  },
  {
    "title": "GOV'T MULE",
    "support": "",
    "isoDate": "2000-07-23",
    "date": "SUN JULY 23, 2000",
    "sourceUrl": "https://www.concertarchives.org/venues/the-ranchbowl"
  },
  {
    "title": "STEEL PULSE",
    "support": "",
    "isoDate": "1992-02-25",
    "date": "TUE FEBRUARY 25, 1992",
    "sourceUrl": "https://www.concertarchives.org/venues/the-ranchbowl"
  },
  {
    "title": "JOHNNY WINTER",
    "support": "SUE FOLEY",
    "isoDate": "1991-11-20",
    "date": "WED NOVEMBER 20, 1991",
    "sourceUrl": "https://www.concertarchives.org/venues/the-ranchbowl"
  },
  {
    "title": "STEVE MORSE BAND",
    "support": "",
    "isoDate": "1990-06-21",
    "date": "THU JUNE 21, 1990",
    "sourceUrl": "https://www.concertarchives.org/venues/the-ranchbowl"
  },
  {
    "title": "STEVE MORSE BAND",
    "support": "",
    "isoDate": "1990-01-29",
    "date": "MON JANUARY 29, 1990",
    "sourceUrl": "https://www.concertarchives.org/venues/the-ranchbowl"
  },
  {
    "title": "BLUES TRAVELER",
    "support": "",
    "isoDate": "1994-11-02",
    "date": "WED NOVEMBER 2, 1994",
    "sourceUrl": "https://www.setlist.fm/setlist/blues-traveler/1994/ranch-bowl-omaha-ne-4bd01fde.html"
  },
  {
    "title": "THE OFFSPRING",
    "support": "RANCID / RITUAL DEVICE",
    "isoDate": "1994-10-15",
    "date": "SAT OCTOBER 15, 1994",
    "sourceUrl": "https://www.concertarchives.org/concerts/the-offspring-rancid-ritual-device"
  },
  {
    "title": "KREATOR",
    "support": "",
    "isoDate": "1991-04-04",
    "date": "THU APRIL 4, 1991",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=28"
  },
  {
    "title": "WARREN ZEVON",
    "support": "",
    "isoDate": "1990-11-19",
    "date": "MON NOVEMBER 19, 1990",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=28"
  },
  {
    "title": "SOUL ASYLUM",
    "support": "RUN WESTY RUN",
    "isoDate": "1990-10-16",
    "date": "TUE OCTOBER 16, 1990",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=28"
  },
  {
    "title": "fIREHOSE",
    "support": "BIG TROUBLE HOUSE",
    "isoDate": "1990-10-10",
    "date": "WED OCTOBER 10, 1990",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=28"
  },
  {
    "title": "BOB MOULD",
    "support": "ULTRA VIVID SCENE",
    "isoDate": "1990-10-08",
    "date": "MON OCTOBER 8, 1990",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=28"
  },
  {
    "title": "MODERN ENGLISH",
    "support": "",
    "isoDate": "1990-08-12",
    "date": "SUN AUGUST 12, 1990",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=28"
  },
  {
    "title": "D.R.I.",
    "support": "",
    "isoDate": "1990-07-30",
    "date": "MON JULY 30, 1990",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=28"
  },
  {
    "title": "SQUEEZE",
    "support": "",
    "isoDate": "1990-07-01",
    "date": "SUN JULY 1, 1990",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=28"
  },
  {
    "title": "T.S.O.L.",
    "support": "",
    "isoDate": "1990-06-25",
    "date": "MON JUNE 25, 1990",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=28"
  },
  {
    "title": "FAITH NO MORE",
    "support": "CIRCUS OF POWER",
    "isoDate": "1990-06-18",
    "date": "MON JUNE 18, 1990",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=28"
  },
  {
    "title": "ERIC JOHNSON",
    "support": "",
    "isoDate": "1990-06-12",
    "date": "TUE JUNE 12, 1990",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=28"
  },
  {
    "title": "OVERKILL",
    "support": "",
    "isoDate": "1990-04-09",
    "date": "MON APRIL 9, 1990",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=28"
  },
  {
    "title": "THE HOOTERS",
    "support": "",
    "isoDate": "1990-02-05",
    "date": "MON FEBRUARY 5, 1990",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=28"
  },
  {
    "title": "CAMPER VAN BEETHOVEN",
    "support": "",
    "isoDate": "1989-11-14",
    "date": "TUE NOVEMBER 14, 1989",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=28"
  },
  {
    "title": "WARRANT",
    "support": "",
    "isoDate": "1989-04-17",
    "date": "MON APRIL 17, 1989",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=28"
  },
  {
    "title": "NAZARETH",
    "support": "",
    "isoDate": "1988-03-14",
    "date": "MON MARCH 14, 1988",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=28"
  },
  {
    "title": "L.A. GUNS",
    "support": "",
    "isoDate": "1988-03-09",
    "date": "WED MARCH 9, 1988",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=28"
  },
  {
    "title": "THE PURSUIT OF HAPPINESS",
    "support": "",
    "isoDate": "1988-03-05",
    "date": "SAT MARCH 5, 1988",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=29"
  },
  {
    "title": "ARMORED SAINT",
    "support": "",
    "isoDate": "1988-02-24",
    "date": "WED FEBRUARY 24, 1988",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=29"
  },
  {
    "title": "EXODUS",
    "support": "",
    "isoDate": "1988-02-16",
    "date": "TUE FEBRUARY 16, 1988",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=29"
  },
  {
    "title": "RIDE",
    "support": "SLOWDIVE",
    "isoDate": "1992-05-11",
    "date": "MON MAY 11, 1992",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=27"
  },
  {
    "title": "GUARDIAN",
    "support": "CHOP SUEY",
    "isoDate": "1992-05-07",
    "date": "THU MAY 7, 1992",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=27"
  },
  {
    "title": "MR. BUNGLE",
    "support": "",
    "isoDate": "1992-03-22",
    "date": "SUN MARCH 22, 1992",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=27"
  },
  {
    "title": "HELMET",
    "support": "L7",
    "isoDate": "1992-03-18",
    "date": "WED MARCH 18, 1992",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=27"
  },
  {
    "title": "OVERKILL",
    "support": "",
    "isoDate": "1992-03-16",
    "date": "MON MARCH 16, 1992",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=27"
  },
  {
    "title": "JOAN JETT & THE BLACKHEARTS",
    "support": "",
    "isoDate": "1992-01-29",
    "date": "WED JANUARY 29, 1992",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=27"
  },
  {
    "title": "HOLY SOLDIER",
    "support": "HOI POLLOI",
    "isoDate": "1992-07-22",
    "date": "WED JULY 22, 1992",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=27"
  },
  {
    "title": "BRITNY FOX",
    "support": "SLAMMIN' GLADYS",
    "isoDate": "1992-06-24",
    "date": "WED JUNE 24, 1992",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=27"
  },
  {
    "title": "ROXY BLUE",
    "support": "BABYLON A.D. / WILDSIDE",
    "isoDate": "1992-07-26",
    "date": "SUN JULY 26, 1992",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?page=27"
  },
  {
    "title": "BUCKCHERRY",
    "support": "",
    "isoDate": "1999-12-11",
    "date": "SAT DECEMBER 11, 1999",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=1999"
  },
  {
    "title": "TODD SNIDER",
    "support": "",
    "isoDate": "1999-11-28",
    "date": "SUN NOVEMBER 28, 1999",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=1999"
  },
  {
    "title": "ANGRY SALAD / THE SAMPLES",
    "support": "",
    "isoDate": "1999-11-23",
    "date": "TUE NOVEMBER 23, 1999",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=1999"
  },
  {
    "title": "OLD 97'S / ALEJANDRO ESCOVEDO",
    "support": "",
    "isoDate": "1999-10-27",
    "date": "WED OCTOBER 27, 1999",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=1999"
  },
  {
    "title": "MR. BUNGLE",
    "support": "",
    "isoDate": "1999-10-25",
    "date": "MON OCTOBER 25, 1999",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=1999"
  },
  {
    "title": "2 SKINNEE J'S",
    "support": "",
    "isoDate": "1999-09-09",
    "date": "THU SEPTEMBER 9, 1999",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=1999"
  },
  {
    "title": "GWAR",
    "support": "",
    "isoDate": "1999-07-12",
    "date": "MON JULY 12, 1999",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=1999"
  },
  {
    "title": "ZIGGY MARLEY",
    "support": "",
    "isoDate": "1999-07-08",
    "date": "THU JULY 8, 1999",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=1999"
  },
  {
    "title": "FALL OUT BOY",
    "support": "",
    "isoDate": "2003-12-10",
    "date": "WED DECEMBER 10, 2003",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=2003"
  },
  {
    "title": "AMERICAN HEAD CHARGE",
    "support": "",
    "isoDate": "2003-11-28",
    "date": "FRI NOVEMBER 28, 2003",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=2003"
  },
  {
    "title": "SYMPHONY X",
    "support": "",
    "isoDate": "2003-11-25",
    "date": "TUE NOVEMBER 25, 2003",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=2003"
  },
  {
    "title": "ZEBRAHEAD",
    "support": "",
    "isoDate": "2003-11-19",
    "date": "WED NOVEMBER 19, 2003",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=2003"
  },
  {
    "title": "MINDLESS SELF INDULGENCE",
    "support": "",
    "isoDate": "2003-11-18",
    "date": "TUE NOVEMBER 18, 2003",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=2003"
  },
  {
    "title": "KING'S X",
    "support": "",
    "isoDate": "2003-11-16",
    "date": "SUN NOVEMBER 16, 2003",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=2003"
  },
  {
    "title": "EVERCLEAR",
    "support": "KYLE HARVEY / MATT WHIPKEY",
    "isoDate": "2003-11-14",
    "date": "FRI NOVEMBER 14, 2003",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=2003"
  },
  {
    "title": "KING'S X",
    "support": "",
    "isoDate": "2003-10-28",
    "date": "TUE OCTOBER 28, 2003",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=2003"
  },
  {
    "title": "BUZZCOCKS",
    "support": "BILLY TALENT / KILL HANNAH",
    "isoDate": "2003-06-17",
    "date": "TUE JUNE 17, 2003",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=2003"
  },
  {
    "title": "MONSTER MAGNET",
    "support": "",
    "isoDate": "2004-11-23",
    "date": "TUE NOVEMBER 23, 2004",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=2004"
  },
  {
    "title": "ISOLA / THE NADAS",
    "support": "",
    "isoDate": "2004-11-12",
    "date": "FRI NOVEMBER 12, 2004",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=2004"
  },
  {
    "title": "LIT",
    "support": "",
    "isoDate": "2004-11-10",
    "date": "WED NOVEMBER 10, 2004",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=2004"
  },
  {
    "title": "THE CASUALTIES",
    "support": "LOWER CLASS BRATS / MONSTER SQUAD",
    "isoDate": "2004-11-08",
    "date": "MON NOVEMBER 8, 2004",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=2004"
  },
  {
    "title": "THE NADAS",
    "support": "",
    "isoDate": "2004-09-10",
    "date": "FRI SEPTEMBER 10, 2004",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=2004"
  },
  {
    "title": "MELVINS",
    "support": "",
    "isoDate": "2004-09-05",
    "date": "SUN SEPTEMBER 5, 2004",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=2004"
  },
  {
    "title": "TOMMY STINSON",
    "support": "",
    "isoDate": "2004-09-03",
    "date": "FRI SEPTEMBER 3, 2004",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=2004"
  },
  {
    "title": "SHADOWS FALL",
    "support": "AS I LAY DYING / HIMSA / REMEMBERING NEVER",
    "isoDate": "2004-08-12",
    "date": "THU AUGUST 12, 2004",
    "sourceUrl": "https://www.concertarchives.org/venues/ranch-bowl--523438?year=2004"
  }
];
